import CandidatureAddRequest, {
  CandidatureAddRequestCandidatureCreatePlanEntry,
  CandidatureAddRequestCandidatureCreateSolvedOrderEntry,
  CandidatureAddRequestCandidatureEntryType,
} from "../../../api/raily/candidature/add/candidature-add.request";
import CandidatureAddParams from "./candidature-add-params";

const createPlanEntryCandidating = (
  params: CandidatureAddParams,
): CandidatureAddRequestCandidatureCreatePlanEntry => {
  return {
    candidateEntryType:
      CandidatureAddRequestCandidatureEntryType.CREATE_PLAN_ENTRY,
    transportingOrderId: params.transportingOrderUuid,
    taxiCorporationId: params.taxiCorporationUuid,
    givenPlanEntryId: params.givenPlanEntryUuid,
    candidatingSolve: params.solvedOrderUuid,
  };
};

const createSolvedOrderCandidating = (
  params: CandidatureAddParams,
): CandidatureAddRequestCandidatureCreateSolvedOrderEntry => {
  return {
    candidateEntryType:
      CandidatureAddRequestCandidatureEntryType.CREATE_SOLVED_ORDER,
    planEntryId: params.planEntryUuid,
    createPlanEntryId: params.createPlanEntryId,
    transportingOrderId: params.transportingOrderUuid,
    candidatingSolve: params.solvedOrderUuid,
  };
};

const createCandidatureEntries = (params: CandidatureAddParams): any => {
  if (params.givenPlanEntryUuid) return createPlanEntryCandidating(params);

  return createSolvedOrderCandidating(params);
};

const create = (params: CandidatureAddParams): CandidatureAddRequest => {
  return {
    driverId: params.driverUuid,
    candidatureEntries: [createCandidatureEntries(params)],
  };
};

const candidatureAddParamsFactory = {
  create,
};

export default candidatureAddParamsFactory;
